import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-cream flex items-center justify-center p-6">
          <div className="max-w-md text-center">
            <h1 className="font-display text-display-2 text-navy mb-4">Something went wrong</h1>
            <p className="font-body text-navy/70 mb-6">
              We&apos;re sorry for the inconvenience. Please reload the page or contact us directly.
            </p>
            <a href="tel:8885291315" className="btn-gold">
              Call 888-529-1315
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
